import React from 'react';
import PropTypes from 'prop-types';

import { ColoredPrice } from './styles';

const Price = ({ children: price, ...rest }) => (
  <ColoredPrice {...rest} negative={price < 0}>
    {price < 0 && '-'}
    $
    {Math.abs(price).toFixed(2)}
  </ColoredPrice>
);
Price.propTypes = {
  children: PropTypes.number.isRequired,
};
export default Price;
